var render = function render(){var _vm=this,_c=_vm._self._c;return _c('track',{attrs:{"src":require("../assets/videos/transkript/theresienstadtmp4.de.vtt"),"default":"","id":"Vidtranskript"}})
}
var staticRenderFns = []

export { render, staticRenderFns }